import i18n from "@/shared/i18n";
import uuidV4 from 'uuid'
import SalesService from "@/modules/sales/SalesService";
import {ON_PDF_MODAL_OPEN, ON_AUCTIONEERS_SHEET_GENERATED} from "@/plugins/event-bus/event-bus-names";

export function onReportFinish(vm, data) {
  if (data.status === 'pending') {
    vm.$toast('info', data.message);
  } else if (data.status === 'failed') {
    vm.$toast('error', data.message);
  } else if (data.status === 'completed') {
    const message = vm.$createElement('p', {}, [data.message, ' ', vm.$createElement('a', {
      attrs: {
        href: data.url,
        target: '_blank'
      }
    }, [i18n.t('Download')])]);
    vm.$advancedToast(message, {
      variant: 'success',
      title: 'Success',
      noAutoHide: true
    });
  }
}

export function onExportFinish(vm, data) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }
  const exportNameToModelMap = {
    inventory: i18n.t('Inventories export'),
    invoice: i18n.t('Invoices export')
  }

  let exportName = exportNameToModelMap[data.model] ? exportNameToModelMap[data.model] : i18n.t('Export')
  const id = uuidV4()
  const title = data.type ? i18n.t(`${data.type} Result`) : i18n.t("Exports Result")

  let exportMessage = `${exportName} is ready. ${data.row_count} row(s) generated.`
  if (data.display_name) {
    exportMessage = `${data.display_name} is ready.`
  }

  const h = vm.$createElement
  const vNodesMsg = h('p', {class: ['mb-0']}, [exportMessage])

  const buttons = h(
    'div',
    {class: ['mt-2']},
    [
      h(
        'b-button',
        {
          props: {variant: 'success',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
              window.open(data.url, '_blank')
            }
          }
        },
        i18n.t('Download')
      ),
      h(
        'b-button',
        {
          class: ['ml-2'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: title,
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}


export function onAuctionCatalogGenerationFinish(vm, data) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }

  if (!data.finished) {
    return;
  }

  let exportMessage = vm.$i18n.t("Catalog for {sale_no} is ready", {sale_no: data.sale_no})
  const h = vm.$createElement
  const vNodesMsg = h('p', {class: ['mb-0']}, [exportMessage])
  const id = uuidV4()

  const buttons = h(
    'div',
    {class: ['mt-2']},
    [
      h(
        'b-button',
        {
          props: {variant: 'success',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
              SalesService.viewAuctionCatalog(vm, data.auction_uuid, data.sale_no)
            }
          }
        },
        i18n.t('View')
      ),
      h(
        'b-button',
        {
          class: ['ml-2'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: vm.$i18n.t('Catalog Export'),
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}

export function onBulkEditTemplateExportFinish(vm, data) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }

  const exportMessage = data.display_name
    ? `${data.display_name} is ready.`
    : i18n.t("Bulk Edit Template is ready.");
  const h = vm.$createElement
  const vNodesMsg = h('p', {class: ['mb-0']}, [exportMessage])
  const id = uuidV4()

  const buttons = h(
    'div',
    {class: ['mt-2']},
    [
      h(
        'b-button',
        {
          props: {variant: 'success',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
              window.open(data.url, '_blank')
            }
          }
        },
        i18n.t('Download')
      ),
      h(
        'b-button',
        {
          class: ['ml-2'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: i18n.t('Bulk Edit Template Export'),
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}

export function onAuctionFileExportFinish(vm, data, type) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }

  let exportMessage = vm.$i18n.t("CSV export for {sale_no} is ready", {sale_no: data.sale_no})
  let title = vm.$i18n.t('Auction CSV Export');
  if (type === 'pdf') {
    exportMessage = vm.$i18n.t("PDF export for {sale_no} is ready", {sale_no: data.sale_no})
    title = vm.$i18n.t('Auction PDF Export');
  } else if (type === 'xlsx') {
    exportMessage = vm.$i18n.t("Excel export for {sale_no} is ready", {sale_no: data.sale_no})
    title = vm.$i18n.t('Auction Excel Export');
  } else if (type === 'auction_sale_profile_pdf') {
    exportMessage = vm.$i18n.t("Sale profile for {sale_no} is ready", {sale_no: data.sale_no})
    title = vm.$i18n.t('Auction Sale Profile Export');
  } else if (type === 'auction_auctioneers_book') {
    exportMessage = vm.$i18n.t("Auctioneer's book for {sale_no} is ready", {sale_no: data.sale_no})
    title = vm.$i18n.t("Auctioneer's Book Export");
  }

  const h = vm.$createElement
  const vNodesMsg = h('p', {class: ['mb-0']}, [exportMessage])
  const id = uuidV4()

  const buttons = h(
    'div',
    {class: ['mt-2']},
    [
      h(
        'b-button',
        {
          props: {variant: 'success',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
              window.open(data.url, '_blank')
            }
          }
        },
        i18n.t('Download')
      ),
      h(
        'b-button',
        {
          class: ['ml-2'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: title,
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}

export function onInventoryOverviewGenerationFinish(vm, data) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }

  if (!data.finished) {
    return;
  }

  let exportMessage = vm.$i18n.t("Inventory overview export is ready")
  const h = vm.$createElement
  const vNodesMsg = h('p', {class: ['mb-0']}, [exportMessage])
  const id = uuidV4()

  const buttons = h(
    'div',
    {class: ['mt-2']},
    [
      h(
        'b-button',
        {
          props: {variant: 'success',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
              console.log(data);
              console.log(data.url);
              vm.$evBus.$emit(ON_PDF_MODAL_OPEN, {
                title: vm.$i18n.t(`Inventory Overdue Export`),
                data: {pdf_url: data.url}
              });
            }
          }
        },
        i18n.t('View')
      ),
      h(
        'b-button',
        {
          class: ['ml-2'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: vm.$i18n.t('Inventory Overview Export'),
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}


export function onExportLotImagesFinish(vm, data) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }
  const exportNameToModelMap = {
    lot_images: i18n.t('Images export'),
    inventory_images: i18n.t('Inventory Images export'),
  }
  const id = uuidV4()


  const exportName = exportNameToModelMap[data.model]
    ? exportNameToModelMap[data.model]
    : i18n.t('Export')

  const title = data.type
    ? i18n.t("{type} Result", {type: data.type})
    : i18n.t("Exports Result")

  const exportMessage = data.display_name
    ? i18n.t("{name} is ready.", {name: data.display_name})
    : i18n.t("{name} is ready. {count} row(s) generated.", {name: exportName, count: data.urls.length})

  const h = vm.$createElement

  const vNodesMsg = h(
    'p',
    {
      style: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    [
      h('p', {class: ['mb-0']}, [exportMessage]),
      data.urls.map((item, index) => h('p',
        {
          on: {
            click: () => window.open(`${item.url}`, '_blank')
          },
          style: {
            cursor: 'pointer',
            color: 'blue',
            textDecoration: 'none',
            marginBottom: 0,
          }
        }, i18n.t("Download Link {idx}", {idx: index + 1})
      ))
    ]
  )

  const buttons = h(
    'div',
    {class: ['mt-2', 'text-right']},
    [
      h(
        'b-button',
        {
          class: ['ml-auto'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: title,
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}


export function onAuctioneersSheetGenerationFinish(vm, data) {
  if (data.error) {
    vm.$errorDialog(data.error);
    return
  }

  if (!data.finished) {
    return;
  }

  let exportMessage = vm.$i18n.t("Auctioneer's Sheet for {sale_no} is ready", {sale_no: data.sale_no})
  if (data.report_type == 'after_sale_auctioneers_sheet') {
    exportMessage = vm.$i18n.t("After Sale Auctioneer's Sheet for {sale_no} is ready", {sale_no: data.sale_no})
  }
  vm.$evBus.$emit(ON_AUCTIONEERS_SHEET_GENERATED, {
    'sale_uuid': data.auction_uuid,
    'report_type': data.report_type
  });
  const h = vm.$createElement
  const vNodesMsg = h('p', {class: ['mb-0']}, [exportMessage])
  const id = uuidV4()

  const buttons = h(
    'div',
    {class: ['mt-2']},
    [
      h(
        'b-button',
        {
          props: {variant: 'success',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
              if (data.report_type == 'auctioneers_sheet') {
                SalesService.generateOrRetrieveAuctioneersSheet(vm, data.auction_uuid, false);
              } else {
                SalesService.generateOrRetrieveAfterSaleAuctioneersSheet(vm, data.auction_uuid, false);
              }
            }
          }
        },
        i18n.t('View')
      ),
      h(
        'b-button',
        {
          class: ['ml-2'],
          props: {variant: 'secondary',},
          on: {
            click: () => {
              vm.$bvToast.hide(id);
            }
          }
        },
        i18n.t('Dismiss')
      ),
    ]
  )

  vm.$bvToast.toast([vNodesMsg, buttons], {
    id: id,
    title: vm.$i18n.t("Auctioneer's Sheet Report"),
    variant: 'info',
    toaster: 'b-toaster-top-center',
    noAutoHide: true
  })
}
